{
  "module-title": "Closing Disclosure",
  "page-heading": "Your Closing Disclosure",

  "role-buyer": "Buyer",
  "role-seller": "Seller",
  "role-lender": "Lender",
  "role-title-company": "Title Company",
  "role-agent": "Real Estate Agent",
  "role-listing-agent": "Listing Agent",
  "role-selling-agent": "Selling Agent",

  "overview-section": "Transaction Overview",
  "overview-purchase-price": "Purchase Price",
  "overview-loan-amount": "Loan Amount",
  "overview-down-payment": "Down Payment",
  "overview-closing-date": "Closing Date",
  "overview-property-address": "Property Address",
  "overview-loan-estimate": "Loan Estimate",

  "buyer-cash-header": "Your Cash Needed at Closing",
  "buyer-cash-description": "This is the total amount of money you need to bring to closing. It includes your down payment, closing costs not paid by the seller, and any other adjustments due at signing.",
  "buyer-cash-breakdown": "Cash Breakdown",
  "buyer-total-due": "Total Due from Buyer",

  "seller-proceeds-header": "Your Proceeds from Sale",
  "seller-proceeds-description": "This is the net amount of money you will receive after all costs, commissions, and payoffs are deducted from the sale price. It represents your equity in the home.",
  "seller-proceeds-breakdown": "Proceeds Breakdown",
  "seller-total-due": "Total Proceeds to Seller",

  "lender-summary": "Lender Information",
  "lender-name": "Lender Name",
  "lender-loan-number": "Loan Number",
  "lender-loan-type": "Loan Type",
  "lender-interest-rate": "Interest Rate",
  "lender-monthly-payment": "Estimated Monthly Payment",

  "property-section": "Property Information",
  "property-map": "Property Location",
  "property-parcel-number": "Parcel Number",
  "property-legal-description": "Legal Description",

  "charges-section": "Closing Costs Breakdown",
  "charges-expand-detail": "Show Details",
  "charges-collapse-detail": "Hide Details",
  "charges-total": "Total Closing Costs",

  "title-insurance-section": "Property Protection Insurance",
  "title-insurance-title": "Property Protection Insurance",
  "title-insurance-what-is": "This is insurance that protects you and the lender against problems with the property ownership. If someone later claims they have rights to your property or discovers liens or claims against it, this insurance covers your legal costs and any financial losses. It's a one-time premium paid at closing that protects you for as long as you own the property.",
  "title-insurance-who-pays": "Typically the seller pays for the owner's policy and lender's policy at closing",
  "title-insurance-when": "Premium is paid at closing",
  "title-insurance-why": "Your lender requires this insurance to protect their investment. You can also get an owner's policy to protect yourself against title problems that might not be covered by the lender's policy.",
  "title-insurance-lenders-policy": "Lender's Policy",
  "title-insurance-lenders-policy-detail": "Protects the lender's investment only. Costs about 0.5-1% of the loan amount. Expires when the loan is paid off.",
  "title-insurance-owners-policy": "Owner's Policy",
  "title-insurance-owners-policy-detail": "Protects your ownership interest. Recommended even though optional. Costs similar to lender's policy. Protects you indefinitely.",

  "escrow-section": "Escrow Account Information",
  "escrow-header": "Escrow Account",
  "escrow-what-is": "An escrow account is a special account held in trust where we collect money each month to pay your homeowners insurance and property taxes. Each month, a portion of your mortgage payment goes into this account. When your insurance and taxes come due, we pay them from this account. This protects you by making sure these critical payments don't get missed, and it protects the lender by ensuring the property stays insured and taxes stay current.",
  "escrow-who-manages": "Your lender manages this account",
  "escrow-when": "Deposits start at closing",
  "escrow-why": "Your lender requires this to ensure your property taxes and insurance always stay paid. If these payments were missed, it could put the property at risk of foreclosure or loss of insurance coverage.",
  "escrow-insurance-breakdown": "Insurance Deposit",
  "escrow-insurance-amount": "Initial insurance deposit",
  "escrow-insurance-explanation": "We're collecting an upfront payment for about two to three months of homeowners insurance premiums to start your escrow account",
  "escrow-taxes-breakdown": "Property Tax Deposit",
  "escrow-taxes-amount": "Initial property tax deposit",
  "escrow-taxes-explanation": "We're collecting an upfront payment to cover property taxes until the next payment is due. This amount varies based on your local property tax rates and your county's payment schedule",
  "escrow-monthly-breakdown": "Monthly Escrow Breakdown",
  "escrow-monthly-insurance": "Monthly insurance payment portion",
  "escrow-monthly-taxes": "Monthly property tax portion",
  "escrow-monthly-total": "Total monthly escrow payment",

  "recording-section": "Government Recording Fees",
  "recording-title": "Government Recording Costs",
  "recording-what-is": "When you buy property, several legal documents (deed, mortgage, and other agreements) must be filed with the county government. These fees pay for that official filing and recording process. The recorder's office keeps these documents as public record.",
  "recording-who-pays": "Typically buyer and seller each pay their own recording costs, though this can vary by state",
  "recording-when": "Paid at closing",
  "recording-why": "Recording protects your ownership rights by creating an official public record. It also ensures the lender's mortgage is properly filed and has priority if there are competing claims.",
  "recording-deed": "Deed Recording",
  "recording-deed-detail": "Cost to record the deed (your ownership transfer document)",
  "recording-mortgage": "Mortgage Recording",
  "recording-mortgage-detail": "Cost to record the mortgage or deed of trust (the lender's interest in the property)",
  "recording-other": "Other Recording Fees",
  "recording-other-detail": "Costs for recording other documents like affidavits, surveys, or lien releases",

  "appraisal-section": "Property Valuation",
  "appraisal-title": "Property Valuation Fee",
  "appraisal-what-is": "The lender requires a professional appraisal to confirm the property is worth the amount being borrowed. An appraiser is an independent professional who inspects the property and compares it to similar properties that recently sold in the area. This protects the lender by ensuring they're not lending more than the property is worth.",
  "appraisal-who-pays": "Buyer typically pays (often paid during pre-approval or pre-closing)",
  "appraisal-when": "Usually completed before closing",
  "appraisal-why": "If the property appraises lower than the purchase price, it affects the loan amount and your down payment",
  "appraisal-report": "Appraisal Report",
  "appraisal-report-detail": "Detailed professional assessment of property value based on condition, location, and comparable sales",

  "inspection-section": "Home Inspection",
  "inspection-title": "Home Inspection Fee",
  "inspection-what-is": "A home inspector examines the condition of the house and identifies any existing problems with the structure, systems, or major components like the roof, foundation, plumbing, electrical, heating, and cooling. This inspection gives you a detailed picture of the home's condition before you're committed to buying it.",
  "inspection-who-pays": "Buyer typically pays",
  "inspection-when": "Typically done before closing (during the inspection period specified in the offer)",
  "inspection-why": "This helps you make an informed decision about the property and negotiate repairs or credits if major issues are discovered",
  "inspection-report": "Inspection Report",
  "inspection-report-detail": "Detailed written report of inspector's findings, conditions, and recommendations",

  "survey-section": "Property Boundary Check",
  "survey-title": "Property Boundary Check",
  "survey-what-is": "A surveyor is a licensed professional who determines the exact boundaries and size of your property using legal descriptions, property records, and on-site measurements. They create an official survey map showing where your property line falls and where improvements like buildings, driveways, and fences are located.",
  "survey-who-pays": "Seller or buyer (terms set in purchase agreement)",
  "survey-when": "Usually completed before closing if required",
  "survey-why": "A survey prevents boundary disputes, confirms improvements are within your property line, and is required by many lenders",
  "survey-update": "Updated Survey",
  "survey-update-detail": "Surveyor confirms boundaries and locates structures on the property",

  "origination-section": "Loan Origination",
  "origination-title": "Loan Origination Fee",
  "origination-what-is": "This fee covers the lender's costs to process, underwrite, and approve your loan application. It includes costs for reviewing your financial information, pulling credit reports, verifying employment and assets, and coordinating with underwriters.",
  "origination-who-pays": "Buyer typically pays (may be negotiated)",
  "origination-when": "Paid at closing",
  "origination-why": "Lenders charge this fee to cover their administrative and underwriting costs. It's typically expressed as a percentage of the loan amount (e.g., 0.5% to 1.5%).",
  "origination-percentage": "Origination Fee (%)",
  "origination-percentage-detail": "Percentage of loan amount charged as origination fee",

  "points-section": "Loan Points",
  "points-title": "Loan Points (Discount Points)",
  "points-what-is": "Points are an optional way to lower your interest rate. One point equals 1% of the loan amount. By paying points upfront at closing, you permanently reduce your interest rate, which lowers your monthly mortgage payment. This is a trade-off: you pay more cash at closing to save money on payments over time.",
  "points-who-pays": "Buyer pays if they choose to (sometimes negotiated with seller)",
  "points-when": "Paid at closing (optional)",
  "points-why": "Points make sense if you plan to stay in the home long enough to recoup the upfront cost through lower monthly payments. Generally, every point paid reduces the interest rate by about 0.25%.",
  "points-discount": "Discount Points",
  "points-discount-detail": "Optional prepaid interest to reduce your loan interest rate",
  "points-break-even": "Break-even on points typically occurs after 5-7 years",

  "lender-credits-section": "Lender Credits",
  "lender-credits-title": "Lender Credits (Lender Help)",
  "lender-credits-what-is": "These are credits or concessions from the lender to help pay some of your closing costs. The lender offers this in exchange for you accepting a higher interest rate. It's a way for the lender to help offset your out-of-pocket closing costs.",
  "lender-credits-who-pays": "Lender provides this credit",
  "lender-credits-when": "Applied at closing",
  "lender-credits-why": "This option helps borrowers who need help with closing costs but are willing to accept a slightly higher interest rate in return",
  "lender-allowance": "Lender Allowance",
  "lender-allowance-detail": "Credit from lender applied toward your closing costs",

  "processing-section": "Loan Processing",
  "processing-title": "Loan Processing Fee",
  "processing-what-is": "This fee covers the cost of processing your loan application. This includes reviewing documents, ordering appraisals, pulling credit, coordinating underwriting, and preparing closing documents.",
  "processing-who-pays": "Buyer typically pays",
  "processing-when": "Paid at closing",

  "underwriting-section": "Loan Underwriting",
  "underwriting-title": "Loan Underwriting Fee",
  "underwriting-what-is": "This fee covers the underwriter's review of your complete loan file to ensure it meets the lender's standards and the investor's requirements. The underwriter verifies all your financial information and ensures the property meets lending criteria.",
  "underwriting-who-pays": "Buyer typically pays",
  "underwriting-when": "Paid at closing",

  "credit-section": "Credit Report",
  "credit-title": "Credit Report Fee",
  "credit-what-is": "The lender needs to pull your credit report to assess your creditworthiness. This fee covers the cost of obtaining and reviewing your credit history from the major credit bureaus.",
  "credit-who-pays": "Buyer typically pays",
  "credit-when": "Paid at closing",

  "commissions-section": "Real Estate Commissions",
  "commissions-title": "Real Estate Commissions",
  "commissions-what-is": "Real estate agents help sell properties and show properties to buyers. They earn a commission as a percentage of the sale price, typically split between the listing agent (seller's agent) and the selling agent (buyer's agent). Commissions are usually 5-6% of the sale price.",
  "commissions-who-pays": "Seller typically pays from the sale proceeds",
  "commissions-when": "Paid at closing from seller's proceeds",
  "commissions-why": "Agents provide valuable services including marketing the property, showing to potential buyers, negotiating offers, and coordinating the closing process",
  "commissions-selling": "Selling Agent Commission",
  "commissions-selling-detail": "Commission paid to the buyer's agent",
  "commissions-listing": "Listing Agent Commission",
  "commissions-listing-detail": "Commission paid to the seller's agent",

  "earnest-section": "Earnest Money Deposit",
  "earnest-title": "Earnest Money Deposit",
  "earnest-what-is": "When you made an offer to buy the property, you deposited earnest money to show you were serious about buying. This money is held in a trust account by the title company or escrow agent. At closing, this earnest money is applied toward your down payment or closing costs.",
  "earnest-who-pays": "Buyer deposits (already paid during offer stage)",
  "earnest-when": "Deposited when offer is made; applied at closing",
  "earnest-why": "This shows the seller you're a serious buyer. If the sale falls through for reasons within your control, the seller can keep this money.",
  "earnest-if-deal-falls": "If the deal falls through for valid reasons (home inspection failed, appraisal came in too low, financing fell through), you get this money back. If it's your fault, the seller keeps it.",
  "earnest-amount": "Earnest Money Amount",
  "earnest-amount-detail": "Deposit already made toward down payment",

  "payout-section": "Existing Loan Payoffs",
  "payout-title": "Existing Loan Payoff",
  "payout-what-is": "If the seller has an existing mortgage or other lien on the property, that debt must be paid off at closing from the sale proceeds. This is called a payoff.",
  "payout-who-pays": "Seller's proceeds are used to pay off existing debt",
  "payout-when": "Paid at closing from seller's proceeds",
  "payout-why": "The title company requires that all liens be cleared so you receive clear ownership of the property",
  "payout-principal": "Payoff Principal",
  "payout-principal-detail": "Remaining balance on seller's existing mortgage",
  "payout-interest": "Payoff Interest (Daily)",
  "payout-interest-detail": "Interest accrued from last payment to closing date",

  "prorations-section": "Daily Adjustments",
  "prorations-title": "Daily Adjustments (Prorations)",
  "prorations-what-is": "When you buy a property, certain costs like property taxes, insurance, and HOA fees are split between the buyer and seller based on the number of days each owned the property during the current billing period. These adjustments are called prorations. This ensures each party pays only for the days they owned the property.",
  "prorations-who-pays": "Split between buyer and seller based on closing date",
  "prorations-when": "Adjusted at closing",
  "prorations-why": "This ensures fair division of expenses. The buyer shouldn't pay a full month of taxes for a day of ownership, and the seller shouldn't leave money on the table for days they did own it.",
  "prorations-taxes": "Property Tax Proration",
  "prorations-taxes-detail": "Your share of property taxes based on days of ownership",
  "prorations-insurance": "Insurance Proration",
  "prorations-insurance-detail": "Your share of homeowners insurance based on closing date",
  "prorations-hoa": "HOA Fee Proration",
  "prorations-hoa-detail": "Your share of homeowners association fees",
  "prorations-utilities": "Utility Proration",
  "prorations-utilities-detail": "Your share of utilities based on ownership period",

  "hoa-section": "Homeowners Association",
  "hoa-title": "Homeowners Association (HOA)",
  "hoa-what-is": "An HOA is an organization of homeowners in a community that sets rules, maintains common areas, and collects fees from all residents. If the property is part of an HOA community, you'll need to pay these monthly fees.",
  "hoa-who-pays": "Each homeowner pays monthly",
  "hoa-when": "Ongoing monthly payments after closing",
  "hoa-why": "HOA fees maintain common areas, provide community services, and maintain property values in the community",
  "hoa-transfer": "HOA Transfer Fee",
  "hoa-transfer-detail": "One-time fee to transfer your home into the HOA records",
  "hoa-status": "HOA Status Report",
  "hoa-status-detail": "Information about the HOA, rules, reserves, and financial status",

  "settlement-section": "Settlement Balancing",
  "settlement-balance-title": "Settlement Balancing Table",
  "settlement-summary": "This table shows how the settlement figures balance between buyer and seller after all costs, credits, and adjustments.",
  "settlement-buyer-side": "Buyer's Side",
  "settlement-seller-side": "Seller's Side",
  "settlement-buyer-debit": "Amount Due from Buyer",
  "settlement-buyer-credit": "Amount Paid for Buyer",
  "settlement-seller-debit": "Amount Due from Seller",
  "settlement-seller-credit": "Amount Received by Seller",

  "funding-section": "Lender Funding",
  "funding-title": "Lender Funding Information",
  "funding-loan-amount": "Loan Amount Being Funded",
  "funding-due-date": "Funds Due from Lender",
  "funding-wire-info": "Wire Transfer Instructions",

  "ui-expand-all": "Expand All",
  "ui-collapse-all": "Collapse All",
  "ui-print": "Print Disclosure",
  "ui-download": "Download PDF",
  "ui-language": "Language",
  "ui-english": "English",
  "ui-spanish": "Español",
  "ui-loading": "Loading closing information...",
  "ui-error-generic": "Something went wrong. Please try again.",
  "ui-error-loading": "We couldn't load your closing disclosure. This might be temporary. Please try again.",
  "ui-error-missing-order": "No order found. Please go back and select a valid order.",
  "ui-error-empty-charges": "No charges found for this order.",
  "ui-error-server": "The server is temporarily unavailable. Please check back in a few moments.",
  "ui-error-permission": "You don't have permission to view this closing disclosure.",
  "ui-retry": "Try Again",
  "ui-retry-message": "Having trouble? Try refreshing the page or contact support if the problem continues.",
  "ui-loading-message": "Preparing your closing disclosure information...",
  "ui-empty-state": "Your closing disclosure will appear here once we have all the necessary information.",
  "ui-close": "Close",
  "ui-back": "Back",
  "ui-next": "Next",
  "ui-label-what": "What is this?",
  "ui-label-who-pays": "Who pays this?",
  "ui-label-when": "When is this paid?",
  "ui-label-why": "Why is this charge?",
  "ui-not-applicable": "Not applicable",

  "summary-header": "Closing Summary",
  "summary-total-due-buyer": "Total Due from Buyer",
  "summary-total-due-seller": "Total Due from Seller",
  "summary-loan-amount": "Loan Amount",
  "summary-down-payment": "Down Payment",

  "legal-disclaimer": "Important Information",
  "legal-disclaimer-text": "This Closing Disclosure provides an itemized list of all charges that will be collected at closing. If you have questions about any charge, please contact the closing agent or your real estate professional. Some amounts may be estimates and subject to final adjustment at closing.",
  "legal-earnest-note": "Your earnest money deposit has already been collected and will be credited toward your down payment and closing costs at closing.",
  "legal-inspection-notice": "If the home inspection revealed defects, the inspection report may have been used to negotiate credits or repairs",

  "total-due": "Total Due",
  "total-received": "Total Received",
  "amount": "Amount",
  "description": "Description",
  "date": "Date",
  "paid-by": "Paid By",
  "paid-to": "Paid To",
  
   "property-coordinates": "Coordinates",
   "no-properties-available": "No properties available",

   "participants-title": "Participants",
   "participants-buyers": "Buyers",
   "participants-sellers": "Sellers",
   "participants-lenders": "Lenders",
   "participants-empty": "No participants",
   
    "ui-error-generic": "An error occurred",
    "ui-retry-message": "There was a problem loading the closing disclosure. Please try again.",
    "ui-retry": "Retry",
    "ui-back": "Go Back",
    "ui-support-contact": "If the problem continues, please contact our support team.",

    "cost-breakdown-title": "Cost Breakdown",
    "details-tab": "Details",
    "cost-breakdown-stacked-bar-title": "Buyer vs Seller Comparison",
    "cost-breakdown-pie-buyer": "Your Costs at Closing",
    "cost-breakdown-pie-seller": "Your Proceeds",

    "roles-buyer": "Buyer",
    "roles-seller": "Seller",

    "categories-earnest": "Earnest Money",
    "categories-commission": "Real Estate Commission",
    "categories-title-charge": "Title Charges",
    "categories-escrow": "Escrow Funds",
    "categories-taxes": "Taxes & Fees",
    "categories-other": "Other Charges",

     "chart-amount": "Amount",
     "chart-total": "Total",
     "chart-percentage": "Percentage",
     "waiting-for-breakdown-data": "Waiting for cost information to be available"
}
